let prevColor = null;
const ioColors = [
  // "e81416",
  "ffa500",
  "faeb36",
  "79c314",

  "487de7",
  // "4b369d",
  "90e0ef",

  "f72585",
  // "00008B",
  "e76f51",
  "2a9d8f",

  "00ff00",
  "ff9966",
  "ff00ff",
  // "0000ff",

  "BA68C8",
  "ff5050",
  "9933ff",
  "0096c7",
];

// https://htmlcolorcodes.com/
const COLOR_CODES = {
  0: "#CA6F1E",
  1: "#28B463",
  2: "#2E86C1",
  3: "#CB4335",
  4: "#138D75",
  5: "#85929E",
  6: "#A93226",
  7: "#884EA0",
  8: "#17A589",
  9: "#D4AC0D",

  11: "#E67E22",
  12: "#2ECC71",
  13: "#E74C3C",
  14: "#9B59B6",
  15: "#F39C12",
  16: "#16A085",
  17: "#3498DB",
  18: "#1ABC9C",
  19: "#F1C40F",

  21: "#A569BD",
  22: "#EB984E",
  23: "#52BE80",
  24: "#AF7AC5",
  25: "#F7DC6F",
  26: "#82E0AA",
  27: "#EC7063",
  28: "#5DADE2",
  29: "#F4D03F",

  31: "#E67E22",
  32: "#2ECC71",
  33: "#E74C3C",
  34: "#9B59B6",
  35: "#F39C12",
  36: "#16A085",
  37: "#3498DB",
  38: "#1ABC9C",
  39: "#F1C40F",

  41: "#A569BD",
  42: "#EB984E",
  43: "#52BE80",
  44: "#AF7AC5",
  45: "#F7DC6F",
  46: "#82E0AA",
  47: "#EC7063",
  48: "#5DADE2",
  49: "#F4D03F",
};

function getColorFromToothNumber(toothNumber) {
  let retval = "#ffffff";
  if (toothNumber > 0) {
    if (COLOR_CODES[toothNumber]) {
      retval = COLOR_CODES[toothNumber];
    } else {
      retval = COLOR_CODES[toothNumber % 10];
    }
  }
//   retval = retval.replace("#", "");
  return retval;
}

export { getColorFromToothNumber };
